import { render, staticRenderFns } from "./comRegion.vue?vue&type=template&id=329f9891&scoped=true&"
import script from "./comRegion.vue?vue&type=script&lang=ts&"
export * from "./comRegion.vue?vue&type=script&lang=ts&"
import style0 from "./comRegion.vue?vue&type=style&index=0&id=329f9891&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329f9891",
  null
  
)

export default component.exports